<div class="card dettaglio-notifica p-4">
    @if (selectedPromemoria) {
    <div class="flex flex-column gap-3">
        <div class="flex justify-content-between align-items-center border-bottom-1 surface-border pb-3">
            <h2 class="m-0">Dettaglio Promemoria</h2>
        </div>

        <div class="grid mt-2">
            <div class="col-6">
                <span class="text-500 text-sm font-semibold uppercase">Creato da</span>
                <p class="mt-1 font-bold text-lg">{{ selectedPromemoria.creatoDa }}</p>
            </div>
            <div class="col-6">
                <span class="text-500 text-sm font-semibold uppercase">Data creazione</span>
                <p class="mt-1 font-bold text-lg">{{ selectedPromemoria.dataCreazione | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
            <div class="col-6">
                <span class="text-500 text-sm font-semibold uppercase">Modificato da</span>
                <p class="mt-1 font-bold text-lg">{{ selectedPromemoria.modificatoDa || '—' }}</p>
            </div>
            <div class="col-6">
                <span class="text-500 text-sm font-semibold uppercase">Data modifica</span>
                <p class="mt-1 font-bold text-lg">{{ selectedPromemoria.dataModifica ?
                    (selectedPromemoria.dataModifica | date:'dd/MM/yyyy HH:mm') : '—' }}</p>
            </div>
        </div>

        <!-- <div class="mt-2">
            <span class="text-500 text-sm font-semibold uppercase">Promemoria</span>
            <pre class="testo-dettaglio mt-2 p-3 surface-ground border-round border-1 surface-border line-height-3">{{ selectedPromemoria.testo }}</pre>
        </div> -->

        <div class="justify-content-end flex mt-2">
            <p-button class="mt-3 mr-3" icon="pi pi-pencil" severity="help"
                label="Modifica promemoria" (onClick)="openEditModal()" />
            <p-button class="mt-3 mr-3" icon="pi pi-trash" severity="danger"
                label="Elimina promemoria" (onClick)="eliminaPromemoria()" />
        </div>
    </div>
    } @else {
    <div class="flex flex-column align-items-center justify-content-center h-full text-500 gap-3">
        <i class="pi pi-inbox text-6xl"></i>
        <span class="text-lg">Seleziona un promemoria per visualizzarne i dettagli</span>
    </div>
    }
</div>

<app-dialog-modal-promemoria
    [mode]="'edit'"
    [promemoriaId]="selectedPromemoria?.promemoriaId"
    [testoEsistente]="selectedPromemoria?.testo"
    [modaleVisibile]="modaleVisibile"
    (closeDialog)="modaleVisibile = false"
    (success)="onPromemoriaModificato()">
</app-dialog-modal-promemoria>
